// ProtectedRoute.js
import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { normalizeRoleName } from "../utility/accountRoles";

const ProtectedRoute = ({
  requiredPermission,
  allowedRoles,
  requireClassroomAccess = false,
  redirectPathAuth = "/login",
  redirectPathPermission = "/unauthorized",
  redirectPathUpgrade = "/upgrade",
}) => {
  const { isAuthenticated, isLoading, permissions, hasClassroomAccess, roleName, isAccountProfileLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to={redirectPathAuth} state={{ from: location }} replace />
    );
  }

  if (allowedRoles && isAccountProfileLoading && !roleName) {
    return <div role="status">Loading account...</div>;
  }

  if (allowedRoles && !allowedRoles.includes(normalizeRoleName(roleName))) {
    return <Navigate to={redirectPathPermission} replace />;
  }

  if (requireClassroomAccess && !hasClassroomAccess) {
    return (
      <Navigate to={redirectPathUpgrade} state={{ from: location }} replace />
    );
  }

  // If a required permission is provided, check if the user has it.
  if (
    requiredPermission &&
    (!permissions || !permissions[requiredPermission])
  ) {
    return <Navigate to={redirectPathPermission} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
